import React from "react";
import Svg, { Path } from "svgs";

import { Icon } from "../../types";

const DarkMode = ({ size, color, ...props }: Icon) => (
  <Svg {...props} viewBox="0 0 24 24" width={size} height={size} fill={color}>
    <Path d="M11.297 2.0447C11.2642 2.38126 11.2501 2.69017 11.2501 2.99064C11.2517 7.38912 13.8823 11.3607 17.9317 13.0781C19.1584 13.5978 20.4702 13.8876 21.8017 13.9331C20.7924 18.9884 16.094 22.4393 10.9683 21.8902C5.84266 21.341 1.98198 16.9731 2.06648 11.8188C2.15098 6.6645 6.15277 2.42553 11.2937 2.0447H11.297ZM11.8487 0.987671H11.8388C5.84494 1.09361 1.03369 5.97986 1.03369 11.9799C1.03369 18.0558 5.95979 22.9819 12.0357 22.9819C17.5351 22.9819 22.1607 18.9178 22.9178 13.5174C22.9394 13.3623 22.8929 13.2054 22.7902 13.0872C22.6875 12.969 22.5386 12.9011 22.382 12.901H22.374C22.3351 12.901 22.3028 12.901 22.1945 12.9103C16.7167 12.9103 12.2762 8.46798 12.2762 2.99064C12.2799 2.52649 12.316 2.06317 12.3845 1.60408C12.4062 1.44898 12.3596 1.2921 12.2569 1.1739C12.1542 1.05571 12.0053 0.987788 11.8487 0.987671Z" />
  </Svg>
);

DarkMode.displayName = "DarkMode";

DarkMode.defaultProps = {
  size: 24,
  color: "currentcolor",
};

export default DarkMode;
